import LoadingSpinner from "Components/Loader/LoadingSpinner";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // ✅ Added
import ForbiddenPage from "../Error/ForbiddenPage"; // ✅ Import this
import AdminDashboard from "./Admin-panel/AdminDashboard";
import StudentDashboard from "./StudentDashboard/StudentDashboard";
import TeacherDashboard from "./TeacherDashboard/TeacherDashboard";
import ConsultantDashboard from "./ConsultantDashboard/ConsultantDashboard";
import AusbildungDashboard from "../../pages/ausbildung/AusbildungDashboard";
import AusbildungEnglishBoundary from "../../pages/ausbildung/AusbildungEnglishBoundary";
import TeacherApprovalGate from "./TeacherDashboard/TeacherApprovalGate";

const RoleBasedDashboard = () => {
  const { roleName, roleNames } = useSelector((state) => state.auth.user);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const view = queryParams.get("view")?.toUpperCase();
  
  // Normalize roles into a single list for checking
  const allRoles = (Array.isArray(roleNames) ? roleNames : [])
    .concat(roleName ? [roleName] : [])
    .map(r => r.toUpperCase());

  if (allRoles.length === 0) {
    return <LoadingSpinner />;
  }

  // 1. If a specific view is requested via URL, try to show that first
  if (view === "ADMIN" && (allRoles.includes("ADMIN") || allRoles.includes("ADMIN_DEVELOPER"))) {
    return <AdminDashboard />;
  }
  if (view === "TEACHER" && (allRoles.includes("TEACHER") || allRoles.includes("TEACHER_MANAGER"))) {
    return allRoles.includes("TEACHER_MANAGER") ? <TeacherDashboard /> : <TeacherApprovalGate><TeacherDashboard /></TeacherApprovalGate>;
  }
  if (view === "CONSULTANT" && allRoles.includes("CONSULTANT")) {
    return <ConsultantDashboard />;
  }
  if (view === "AUSBILDUNG_MANAGER" && allRoles.includes("AUSBILDUNG_MANAGER")) {
    return <AusbildungEnglishBoundary><AusbildungDashboard /></AusbildungEnglishBoundary>;
  }
  if (view === "STUDENT" && allRoles.includes("STUDENT")) {
    return <StudentDashboard />;
  }

  // 2. Default Fallback (Priority Order)
  if (allRoles.includes("ADMIN") || allRoles.includes("ADMIN_DEVELOPER")) {
    return <AdminDashboard />;
  } else if (allRoles.includes("TEACHER") || allRoles.includes("TEACHER_MANAGER")) {
    return allRoles.includes("TEACHER_MANAGER") ? <TeacherDashboard /> : <TeacherApprovalGate><TeacherDashboard /></TeacherApprovalGate>;
  } else if (allRoles.includes("CONSULTANT")) {
    return <ConsultantDashboard />;
  } else if (allRoles.includes("AUSBILDUNG_MANAGER")) {
    return <AusbildungEnglishBoundary><AusbildungDashboard /></AusbildungEnglishBoundary>;
  } else if (allRoles.includes("STUDENT")) {
    return <StudentDashboard />;
  } else {
    return <ForbiddenPage />;
  }
};

export default RoleBasedDashboard;
